module.exports = __webpack_public_path__ + "static/media/donation.93f5a5fd.jpg";